import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckSquare, Square } from 'lucide-react';

function OnboardingChecklist({ onboarding }) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  if (!onboarding || onboarding.isComplete) return null;

  const steps = [
    { key: 'step1', done: true, label: t('dashboard.setup.step1') },
    { key: 'step2', done: onboarding.employeesAdded, label: t('dashboard.setup.step2'), to: '/team' },
    { key: 'step3', done: onboarding.scheduleBuilt, label: t('dashboard.setup.step3'), to: '/scheduler' },
  ];

  return (
    <div className="mt-6 rounded-xl bg-white border border-gray-200 shadow-sm p-5">
      <h3 className="text-sm font-semibold text-gray-800 mb-3">{t('dashboard.setup.title')}</h3>
      <ul className="space-y-2 text-sm">
        {steps.map((step) => (
          <li key={step.key} className="flex items-center gap-2">
            {step.done ? (
              <CheckSquare size={16} className="text-green-500 flex-shrink-0" />
            ) : (
              <Square size={16} className="text-gray-300 flex-shrink-0" />
            )}
            {step.done || !step.to ? (
              <span className={step.done ? 'text-gray-500' : 'text-gray-700'}>{step.label}</span>
            ) : (
              <button
                onClick={() => navigate(step.to)}
                className="text-orange-600 hover:text-orange-700 font-medium"
              >
                {step.label} →
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default OnboardingChecklist;